var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gallery" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", { staticClass: "gallery__row gallery__row--tabs" }, [
          _c(
            "div",
            { staticClass: "tabs" },
            _vm._l(_vm.collections, function(collection) {
              return _c(
                "a",
                {
                  key: collection.id,
                  staticClass: "tabs__item",
                  class: {
                    "tabs__item--active":
                      collection.id == _vm.selectedCollectionId
                  },
                  attrs: { href: "/" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.setSelectedCollection(collection.id)
                    }
                  }
                },
                [_vm._v(_vm._s(collection.heading))]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.collections, function(collection) {
          return _c("gallery-collection", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: collection.id == _vm.selectedCollectionId,
                expression: "collection.id == selectedCollectionId"
              }
            ],
            key: collection.id,
            attrs: { collection: collection }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }